import { Injectable } from '@angular/core';

import { TaLazyTranslationService } from '@ta/translation';

@Injectable({
  providedIn: 'root',
})
export class AppTranslationApplication extends TaLazyTranslationService {
  constructor() {
    super('app', true);
  }
}
